<template>
    <widget-settings-dialog
        class="deq-reset online-profile-settings-dialog"
        :model="model"
        :dto="profileDialogData"
        @input="onDefaultSettingsChange" width="700px">

        <template v-slot:title-inputs>
               <drop-down-input v-model="selectedFontSize" label="Font size" :options="fontSize" style="width: 80px"/>
               <drop-down-input v-model="selectedNumberFormat" label="Numbers" :options="numberFormat" style="width: 80px"/>
               <drop-down-input v-model="selectedGroupBy" label="Group by" :options="groupByOptions" style="width: 80px"/>
        </template>

        <OpsdForm
            :initial-graph-type="initialGraphType"
            :initial-profiles="initialProfiles"
            @form-updated="emitData"
        />
    </widget-settings-dialog>
</template>

<script>
import WidgetSettingsDialog from "@/dashboards/widgets/WidgetSettingsDialog.vue";
import OpsdForm from "@/dashboards/widgets/onlineprofile/OpsdForm.vue";
import DropDownInput from "@/components/inputs/DropDownInput.vue";

export default {
    name: "OnlineProfileMetricSettings",
    components: {DropDownInput, WidgetSettingsDialog, OpsdForm},
    
    props: {
        // Backbone metric model
        model: Object,

        definitionsList: [],

    },
    
    data() {
        return {
            // This gets populated by WidgetSettingsDialog on mount
            profileDialogData: {
                attrs: {},
                selectedList: [],
            },
            fontSize: [{id: 10}, {id: 12}, {id: 14}, {id: 16}, {id: 18}],
            selectedFontSize: this.model.attributes['font-size'] || 14,

            numberFormat: [{id: '9.2k'}, {id: '9 200'}],
            selectedNumberFormat: this.model.attributes['number-format'] || '9 200',

            dateFormat: [{id: 'Auto'}, {id: '29'}, {id: 'Sat 29'}, {id: 'Feb 29'}, {id: 'Feb'}, {id: 'Hidden'}],
            selectedDateFormat: this.model.attributes['date-format'] || 'Auto',

            groupByOptions: [{id: 'Day'}, {id: 'Week'}, {id: 'Month'}, {id: 'Year'}],
            selectedGroupBy: this.model.attributes['group-by'] || 'Day',
        };
    },
    
    computed: {
        attrs() {
            return this.profileDialogData.attrs;
        },

        initialGraphType() {
            const type = this.attrs && this.attrs['chart-type'];
            if (type === 'text') return 'Text Chart';
            if (type === 'lines') return 'Line Chart';
            return 'Line Chart';
        },

        initialProfiles() {
            const profiles = this.attrs && this.attrs.profiles;
            if (!profiles) return [];
            return profiles
        }
    },

    watch: {
        selectedFontSize(newFontSize) {
            this.attrs['font-size'] = newFontSize;
            this.$set(this.profileDialogData.attrs, 'font-size', this.profileDialogData.attrs['font-size']);
        },

        selectedNumberFormat(newNumberFormat) {
            this.attrs['number-format'] = newNumberFormat;
            this.$set(this.profileDialogData.attrs, 'number-format', this.profileDialogData.attrs['number-format']);
        },

        selectedDateFormat(newNumberFormat) {
            this.attrs['date-format'] = newNumberFormat;
            this.$set(this.profileDialogData.attrs, 'date-format', this.profileDialogData.attrs['date-format']);
        },


        selectedGroupBy(updatedGroupBy) {
            this.attrs['group-by'] = updatedGroupBy;
            this.$set(this.profileDialogData.attrs, 'group-by', this.profileDialogData.attrs['group-by']);
        }

    },

    methods: {
        onDefaultSettingsChange(event) {
            // emit the standard settings (title, size, filter, etc.)
            this.$emit('input', event);

            // save settings onto the model on Ok.
            this.$set(this.profileDialogData.attrs, 'chart-type', this.profileDialogData.attrs['chart-type']);
            this.$set(this.profileDialogData.attrs, 'profiles', this.profileDialogData.attrs.profiles);

            this.$emit('form-updated', this.profileDialogData.attrs);
        },

        emitData(formData) {
            if (!this.profileDialogData.attrs) {
                this.profileDialogData.attrs = {};
            }

            let chartType = null;
            switch (formData.graphType) {
                case 'Text Chart':
                    chartType = 'text';
                    break;
                case 'Line Chart':
                    chartType = 'lines';
                    break;
                default:
                    chartType = this.profileDialogData.attrs['chart-type'] || 'lines';
            }

            this.profileDialogData.attrs['chart-type'] = chartType;
            this.profileDialogData.attrs['profiles'] = formData.profiles;
        }
    }
}
</script>

<style scoped>
.online-profile-settings-dialog {


}


</style>
